import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import {
	NO_TRANSPORT_NAME,
	Offer,
	OWN_TRANSPORT_NAME,
	Reservation,
	Service,
	Slot,
	UserContact,
	UserData,
} from '../../../../reservation.model';

import { ReservationSummaryCommonService } from '../../../services/reservation-summary-common.service';
import { MatDialog } from '@angular/material/dialog';
import { ReservationSummaryStoreService } from '../../../services/reservation-summary-store.service';
import { Subscription } from 'rxjs';
import { CancellationStatuses, Status } from '@/common/enums/Status';
import { ReservationService } from '../../../../reservation.service';
import { ReservationAccomodationOfferParticipantDialogComponent } from './reservation-accomodation-offer-participant-dialog/reservation-accomodation-offer-participant-dialog.component';
import { TypeValueFactoryService } from '@/common/type-value-factory.service';
import { ReservationSummaryAcommodationOfferParticipantChangeDialogComponent } from './reservation-summary-acommodation-offer-participant-change-dialog/reservation-summary-acommodation-offer-participant-change-dialog.component';
import { SlotKind } from '@/common/enums/SlotKind';
import { AuthService } from '@/auth/auth.service';
import { CANCELLATION_INSURANCE_SERVICE_ID } from '@/services/service.model';
import { Permissions } from '@/common/enums/Permissions';
import { CANCELLATION_INSURANCE_NAME } from '../reservation-summary-accomodation-offer-rooms/reservation-summary-accomodation-offer-rooms-dialog/reservation-summary-accomodation-offer-rooms-dialog-offer-change-dialog/reservation-summary-accomodation-offer-rooms-dialog-offer-change-dialog.component';
import { ReservationSummaryApiService } from '@/reservation/reservation-summary/services/reservation-summary-api.service';
import { InfoboxService } from '@/common/infobox/infobox.service';

@Component({
	selector: 'app-reservation-accommodation-offer-participant',
	templateUrl: './reservation-accommodation-offer-participant.component.html',
	styleUrls: ['./reservation-accommodation-offer-participant.component.scss'],
})
export class ReservationAccommodationOfferParticipantComponent implements OnInit, OnDestroy {
	@Input() slot: Slot;
	reservation: Reservation;
	cancellationInsurance: Service | undefined;
	readonly OWN_TRANSPORT_NAME = OWN_TRANSPORT_NAME;
	readonly NO_TRANSPORT_NAME = NO_TRANSPORT_NAME;
	readonly Permissions = Permissions;

	readonly CANCELLATION_INSURANCE_NAME = CANCELLATION_INSURANCE_NAME;

	private sub: Subscription;

	constructor(
		public commonService: ReservationSummaryCommonService,
		private readonly store: ReservationSummaryStoreService,
		public reservationService: ReservationService,
		public dialog: MatDialog,
		protected auth: AuthService,
		private readonly reservationSummaryApiService: ReservationSummaryApiService,
		private readonly infoboxService: InfoboxService,
	) {}

	ngOnInit(): void {
		const { reservation } = this.store.getters();
		this.cancellationInsurance = this.slot?.slotServices.find(
			(v) => v.service.serviceType.id === CANCELLATION_INSURANCE_SERVICE_ID,
		);
		this.sub = reservation().subscribe((val) => {
			this.reservation = val;
		});
	}

	ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}

	get offerId() {
		return this.reservation?.offer?.filter((v, index) => {
			const found = v.slot.find((slot) => slot.id === this.slot?.id);
			if (found) return this.reservation.offer[index]?.id;
		})[0]?.id;
	}

	get offer(): Offer {
		return this.reservation.offer.find((offer) => offer.id === this.offerId);
	}

	showCancelDialog() {
		if (this.reservation) {
			this.commonService.showCancelDialog({
				reservationId: this.reservation.id,
				offerId: this.offerId,
				slotId: this.slot?.id,
			});
		}
	}

	get isCanceled() {
		return CancellationStatuses.includes(this.slot?.status as Status);
	}

	get isChild() {
		return this.slot.kind === SlotKind.CHILD;
	}

	enableSlotDragging() {
		this.reservationService.slotDragging = true;
	}

	protected readonly parseInt = parseInt;
	protected readonly Status = Status;

	showParticipantEditDialog(slot: Slot) {
		const emptyUserData: UserData = {
			...TypeValueFactoryService.createUserDataObject(),
			userContacts: [TypeValueFactoryService.createUserContactObject()],
		};

		const emptyUserContactArray: UserContact[] = [TypeValueFactoryService.createUserContactObject()];

		this.dialog.open(ReservationAccomodationOfferParticipantDialogComponent, {
			data: slot.userData
				? {
						...slot,
						userData: {
							...slot.userData,
							userContacts: slot.userData.userContacts.length
								? slot.userData.userContacts
								: emptyUserContactArray,
						},
					}
				: { ...slot, userData: emptyUserData },
		});
	}

	resetCancellationInsurancePrice(id: number): void {
		const payload: Partial<Service> = { id, overwrittenPrice: 0 };
		this.reservationSummaryApiService.patchReservationService(payload).subscribe(() => {
			this.infoboxService.success('Pomyślnie wyzerowano ubezpieczenie od kosztów rezygnacji');
			this.reservationSummaryApiService.actions().getReservation(this.reservation.id);
		});
	}

	protected showChangeParticipantDialog() {
		this.dialog.open(ReservationSummaryAcommodationOfferParticipantChangeDialogComponent, {
			data: this.slot,
			width: '520px',
		});
	}

	protected get isLastParticipantInOffer(): boolean {
		if (!this.reservation) return false;
		const offer = this.reservation.offer.find((value) => value.id === this.offerId);
		const activeSlotsCount = offer.slot.filter(
			(slot) => !CancellationStatuses.includes(slot.status as Status),
		).length;
		return activeSlotsCount <= 1;
	}
}
